import { z } from "zod";
import { LayoutBlockSchema, type LayoutBlock } from "../blocks/instance.schema";
import { RegionPropsSchema } from "../blocks/defs/regions";

const DefaultTopBarLayoutSchema: LayoutBlock[] = [];
const DefaultLeftBarLayoutSchema: LayoutBlock[] = [];
const DefaultLeftDrawerLayoutSchema: LayoutBlock[] = [
  {
    id: "container-1",
    type: "ReaderLayoutContainer",
    props: { 
      xs: {
        layout: "horizontal",
        gap: 1,
        alignItems: "items-center",
        padding: "10px, 5px, 10px, 5px"
      },
      sm: {
        layout: "horizontal",
        gap: 3,
        alignItems: "items-center",
        padding: "20px, 20px, 20px, 20px"
      }
    },
    children: [
      {
        id: "image-1",
        type: "ReaderLayoutImage",
        props: {
          src: 'logo',
          height: 50
        }
      },
      {
        id: "label-1",
        type: "ReaderLayoutLabel",
        props: {
          text: "$publication.title",
          fontsize: "2xl",
          flex: 1,
        }
      },
      {
        id: "button-1",
        type: "ReaderLayoutButton",
        props: {
          arialabel: "$i18n.components.toggle_menu",
          tabindex: 1,
          text: "",
          variant: "link",
          trailingIcon: {
            icon: "i-lucide-x"
          },
          action: {
            type: "toggleLeftDrawer"
          }
        }
      }
    ]
  },
  {
    id: "container-2",
    type: "ReaderLayoutContainer",
    props: {
      layout: "vertical",
      padding: "20px, 0px, 20px, 0px",
      overflowX: "overflow-x-auto",
    },
    children: [
      {
        id: "table-of-contents",
        type: "ReaderLayoutTableOfContents",
        props: {},
      }
    ]
  },
];
const DefaultRightBarLayoutSchema: LayoutBlock[] = [];
const DefaultRightDrawerLayoutSchema: LayoutBlock[] = [
  {
    id: "container-2",
    type: "ReaderLayoutContainer",
    props: {
      layout: "vertical",
      height: "full"
    },
    children: [
      {
        id: "container-3",
        type: "ReaderLayoutContainer",
        props: {
          layout: "horizontal",
          gap: 3,
          alignItems: "items-center",
          padding: "20px, 20px, 20px, 20px",
        },
        children: [
          {
            id: "label-1",
            type: "ReaderLayoutLabel",
            props: {
              text: "$i18n.components.settings",
              fontsize: "xl",
              flex: 1
            }
          },
          {
            id: "button-1",
            type: "ReaderLayoutButton",
            props: {
              arialabel: "$i18n.components.close",
              tabindex: 1,
              text: "",
              variant: "link",
              trailingIcon: {
                icon: "i-lucide-x"
              },
              action: {
                type: "toggleRightDrawer"
              }
            }
          }
        ]
      },
      {
        id: "container-4",
        type: "ReaderLayoutContainer",
        props: {
          overflowX: "overflow-x-auto",
          padding: "0px, 20px, 0px, 20px",
        },
        children: [
          {
            id: "settings-1",
            type: "ReaderLayoutSettings",
            props: {},
          }
        ]
      },
      
    ]
  }
];
const DefaultBottomBarLayoutSchema: LayoutBlock[] = [
  {
    id: "toggle-left-drawer",
    type: "ReaderLayoutButton",
    props: {
      arialabel: "$i18n.components.toggle_menu",
      tabindex: 1,
      text: "",
      variant: "link",
      leadingIcon: {
        icon: "ic:outline-menu"
      },
      action: {
        type: "toggleBottomDrawer"
      }
    },
  },
  {
    id: "navigate-previous",
    type: "ReaderLayoutButton",
    props: {
      arialabel: "$i18n.components.previous",
      tabindex: 2,
      text: "",
      variant: "link",
      leadingIcon: {
        icon: "ic:outline-keyboard-arrow-left"
      },
      action: {
        type: "navigatePrevious"
      }
    },
  },
  {
    id: "progress-slider",
    type: "ReaderLayoutProgressSlider",
    props: {},
  },
  {
    id: "navigate-next",
    type: "ReaderLayoutButton",
    props: {
      arialabel: "$i18n.components.next",
      tabindex: 4,
      text: "",
      variant: "link",
      leadingIcon: {
        icon: "ic:outline-keyboard-arrow-right",
      },
      action: {
        type: "navigateNext"
      }
    },
  }
];
const DefaultBottomDrawerLayoutSchema: LayoutBlock[] = [
  {
    id: "container-1",
    type: "ReaderLayoutContainer",
    props: {},
    children: [
      {
        id: "toggle-left-drawer-2",
        type: "ReaderLayoutButton",
        props: {
          arialabel: "$i18n.components.contents",
          tabindex: 5,
          text: "$i18n.components.contents",
          fontsize: "xs",
          variant: "link",
          leadingIcon: {
            icon: "ic:outline-menu-book",
          },
          action: {
            type: "toggleLeftDrawer"
          }
        },
      },
      {
        id: "show-highlights-4",
        type: "ReaderLayoutButton",
        props: {
          arialabel: "$i18n.components.highlights",
          tabindex: 5,
          text: "$i18n.components.highlights",
          fontsize: "xs",
          variant: "link",
          leadingIcon: {
            icon: "material-symbols:ink-highlighter-move-outline",
          },
          action: {
            type: "showModal",
            target: "highlight-modal"
          }
        },
      },
      {
        id: "show-bookmarks-4",
        type: "ReaderLayoutButton",
        props: {
          arialabel: "$i18n.components.bookmarks",
          tabindex: 5,
          text: "$i18n.components.bookmarks",
          fontsize: "xs",
          variant: "link",
          leadingIcon: {
            icon: "material-symbols:bookmarks",
          },
          action: {
            type: "showModal",
            target: "bookmark-modal"
          }
        },
      },
      {
        id: "toggle-read-aloud",
        type: "ReaderLayoutReadAloudButton",
        props: {
          arialabel: "$i18n.components.read_aloud",
          tabindex: 6,
          text: "$i18n.components.read_aloud",
          fontsize: "xs",
          variant: "link",
          leadingIcon: {
            icon: "ic:baseline-hearing",
          },
        },
      },
      {
        id: "toggle-right-drawer-2",
        type: "ReaderLayoutButton",
        props: {
          arialabel: "$i18n.components.settings",
          tabindex: 7,
          text: "$i18n.components.settings",
          fontsize: "xs",
          variant: "link",
          leadingIcon: {
            icon: "ic:outline-settings",
          },
          action: {
            type: "toggleRightDrawer"
          }
        },
      },
    ],
  },      
];
const DefaultMainLayoutSchema: LayoutBlock[] = [];
const DefaultModalLayoutSchema: LayoutBlock[] = [{
  id: "bookmark-modal",
  type: "ReaderLayoutModal",
  children: [
    {
      id: "bookmarks-2",
      type: "ReaderLayoutBookmarks",
      props: {},
    }
  ],
  props: {
    title: "$i18n.components.bookmarks"
  }
},
{
  id: "highlight-modal",
  type: "ReaderLayoutModal",
  children: [
    {
      id: "highlights-2",
      type: "ReaderLayoutHighlights",
      props: {},
    }
  ],
  props: {
    title: "$i18n.components.highlights"
  }
}]

export const LayoutV1BaseSchema = z.object({
  version: z.literal("layout@1"),
  regionProps: z.object({
    topBar: RegionPropsSchema.extend({
      height: z.number().optional(),
    }).optional(),
    leftBar: RegionPropsSchema.extend({
      width: z.number().optional(),
    }).optional(),
    leftDrawer: RegionPropsSchema.optional(),
    rightBar: RegionPropsSchema.extend({
      width: z.number().optional(),
    }).optional(),
    rightDrawer: RegionPropsSchema.optional(),
    bottomBar: RegionPropsSchema.extend({
      height: z.number().optional(),
    }).optional(),
    bottomDrawer: RegionPropsSchema.optional(),
    main: RegionPropsSchema.optional(),
    modal: z.record(z.string(), RegionPropsSchema.optional()),
  }).partial().optional(),
  regions: z.object({
    topBar: z.array(LayoutBlockSchema).default(DefaultTopBarLayoutSchema),
    leftBar: z.array(LayoutBlockSchema).default(DefaultLeftBarLayoutSchema),
    leftDrawer: z.array(LayoutBlockSchema).default(DefaultLeftDrawerLayoutSchema),
    rightBar: z.array(LayoutBlockSchema).default(DefaultRightBarLayoutSchema),
    rightDrawer: z.array(LayoutBlockSchema).default(DefaultRightDrawerLayoutSchema),
    bottomBar: z.array(LayoutBlockSchema).default(DefaultBottomBarLayoutSchema),
    bottomDrawer: z.array(LayoutBlockSchema).default(DefaultBottomDrawerLayoutSchema),
    main: z.array(LayoutBlockSchema).default(DefaultMainLayoutSchema),
    modal: z.array(LayoutBlockSchema).default(DefaultModalLayoutSchema),
  }).default({
    topBar: DefaultTopBarLayoutSchema,
    leftBar: DefaultLeftBarLayoutSchema,
    leftDrawer: DefaultLeftDrawerLayoutSchema,
    rightBar: DefaultRightBarLayoutSchema,
    rightDrawer: DefaultRightDrawerLayoutSchema,
    bottomBar: DefaultBottomBarLayoutSchema,
    bottomDrawer: DefaultBottomDrawerLayoutSchema,
    main: DefaultMainLayoutSchema,
    modal: DefaultModalLayoutSchema,
  }),
}).default({
  version: "layout@1",
  regionProps: {},
  regions: {
    topBar: DefaultTopBarLayoutSchema,
    leftBar: DefaultLeftBarLayoutSchema,
    leftDrawer: DefaultLeftDrawerLayoutSchema,
    rightBar: DefaultRightBarLayoutSchema,
    rightDrawer: DefaultRightDrawerLayoutSchema,
    bottomBar: DefaultBottomBarLayoutSchema,
    bottomDrawer: DefaultBottomDrawerLayoutSchema,
    main: DefaultMainLayoutSchema,
    modal: DefaultModalLayoutSchema,
  }
});